import { useEnvironment } from '../../lib/application';
import { HttpError } from '../../lib/http';

export const RequireDev = ({ children }: { children: React.ReactNode }) => {
	const env = useEnvironment();

	if (env === 'development') {
		return <>{children}</>;
	}

	throw new HttpError(404);
};
